import ShowDescriptionAction from '@/modules/FileDetail/components/statusTransition/statusTransitionAction/ShowDescriptionAction.tsx';
import { StatusTransitionActionTypes } from '@/modules/FileDetail/components/statusTransition/statusTransitionAction/StatusTransitionAction.type.ts';

export default ({ action, description }: StatusTransitionActionTypes) => {
  if (action === 'showDescription') {
    return <ShowDescriptionAction description={description} />;
  }
  if (action === '') {
    return <></>;
  }
};
